import moment from "moment";
//import { encryptPW } from "../ApiTS/ApiCommonTS";

//date 날짜 기준으로 month 달 이후의 날짜 찾기
export const GetAddMonthDate = (date, month) => {
  // month달 후의 1일
  let addMonthFirstDate = new Date(
    date.getFullYear(),
    date.getMonth() + month,
    1
  );

  // month달 후의 말일
  let addMonthLastDate = new Date(
    addMonthFirstDate.getFullYear(),
    addMonthFirstDate.getMonth() + 1,
    0
  );

  let result = addMonthFirstDate;
  if (date.getDate() > addMonthLastDate.getDate()) {
    result.setDate(addMonthLastDate.getDate());
  } else {
    result.setDate(date.getDate());
  }

  return result;
};

// 서비스 암호화 정보
export const servicePWcrypto = {
  Algo: "aes-192-cbc",
  IV: "peachgrovelinkid",
  Key: function (uid) {
    let key = uid.toString();
    const cnt = 24 - key.length;
    for (let i = 0; i < cnt; ++i) key = "f" + key;
    return key;
  },
};

export const PayHelper = {
  calc_period: function (_type, _start, _end, _join) {
    let mstart = _start instanceof moment ? _start : moment(_start);
    const mend = _end instanceof moment ? _end : moment(_end);
    const mjoin = _join instanceof moment ? _join : moment(_join);

    if (mstart < mjoin) mstart = mjoin;

    return mend.diff(mstart, _type + "s");
  },

  is_next_guar_pd: function (_rec) {
    return _rec.GUAR_PD == "next_pdate";
  },

  is_deposit_guarantee: function (_rec, _isonwer) {
    if (_isonwer) {
      return _rec.GUAR_LDR == "deposit";
    } else {
      return _rec.GUAR_MBR == "deposit";
    }
  },

  get_rewardstep: function (_rewrec, _period) {
    let max = 0;
    const idx = Object.keys(_rewrec).filter((e) => {
      if (Number.isInteger(+e) && _rewrec[e] != null) {
        max = Math.max(max, +e);
        return true;
      } else return false;
    });

    if (_period < max) return _rewrec[_period];

    return _rewrec[max];
  },

  get_maxrewardstep: function (_rewrec, _period) {
    let max = 0;
    const idx = Object.keys(_rewrec).filter((e) => {
      if (Number.isInteger(+e) && _rewrec[e] != null) {
        max = Math.max(max, +e);
        return true;
      } else return false;
    });

    return max;
  },

  get_maxrewardstep_compare_inputperiod: function (_rewrec, _period) {
    let max = 0;
    const idx = Object.keys(_rewrec).filter((e) => {
      if (Number.isInteger(+e) && _rewrec[e] != null) {
        max = Math.max(max, +e);
        return true;
      } else return false;
    });

    if (max > _period) {
      max = _period;
    }

    return max;
  },

  get_rewardrt: function (_rewrec, _period) {
    let max = 0;
    const idx = Object.keys(_rewrec).filter((e) => {
      if (Number.isInteger(+e) && _rewrec[e] != null) {
        max = Math.max(max, +e);
        return true;
      } else return false;
    });

    if (_period < max) return _rewrec[_period] / 10000;

    return _rewrec[max] / 10000;
  },

  // 파티장 보증금 계산
  guarantee_owner: function (_subsrec, _start, _end, _join) {
    if (_join == null) _join = _start;

    const period = this.calc_period(_subsrec.SUBS_SHARTM, _start, _end, _join);
    return _subsrec.GUAR_LDRPX * period + _subsrec.GUAR_LMGPX;
  },

  // 파티원 보증금 계산 ( 보증금이나 패널티나 계산은 똑같다)
  guarantee: function (_subsrec, _start, _end, _join) {
    const period = this.calc_period(_subsrec.SUBS_SHARTM, _start, _end, _join);
    return _subsrec.GUAR_MBRPX * period + _subsrec.GUAR_MMGPX;
  },

  // 다음 정산일
  nextpdate: function (payday, now) {
    const n = now == null ? moment() : now;

    const today = moment(n.format("YYYY-MM-DD"));
    let next = moment(n.format("YYYY-MM-") + payday, "YYYY-MM-DD");

    if (next <= today) next = next.add(1, "months");

    return next;
  },

  calc_commission: function (_subsrec, _val) {
    let ret = parseInt(_val * (_subsrec.COMM_MBRRT / 10000));

    return ret;
  },

  // 분담금 계산
  allotment: function (_subsrec, _pdate, _nextpdate, _end, _ownerpdate) {
    let mpdate = _pdate instanceof moment ? _pdate : moment(_pdate);
    const mend = _end instanceof moment ? _end : moment(_end);
    let mowner =
      _ownerpdate instanceof moment ? _ownerpdate : moment(_ownerpdate);
    let mnextpdate =
      _nextpdate instanceof moment ? _nextpdate : moment(_nextpdate);

    if (mend < mnextpdate) mnextpdate = mend;

    if (mend < mowner) mowner = mend;

    const eom = moment(mpdate).endOf("month").date();

    let cur = 0;
    let next = 0;

    if (mnextpdate < mowner) mowner = mnextpdate;

    cur = parseInt(
      (moment.duration(mowner - mpdate).asDays() / eom) * _subsrec.SUBS_FEE
    );
    next = parseInt(
      (moment.duration(mnextpdate - mowner).asDays() / eom) * _subsrec.SUBS_FEE
    );

    let commission = this.calc_commission(_subsrec, cur + next);

    return {
      cur: cur,
      next: next,
      commission: commission,
      total: cur + next + commission,
    };
  },

  returnfee(_fee, _pdate, _lastpdate, _now, _subsrec, _discount = 0) {
    const mpdate = _pdate instanceof moment ? _pdate : moment(_pdate);
    const mlastpdate =
      _lastpdate instanceof moment ? _lastpdate : moment(_lastpdate);
    const mnow = _now instanceof moment ? _now : moment(_now);

    const rate = Math.max(
      mpdate.diff(mnow, "days") / mpdate.diff(mlastpdate, "days"),
      0
    );

    const fee = parseInt(_fee * rate);
    const comm = parseInt(this.calc_commission(_subsrec, _fee) * rate);

    let final = fee + comm;
    let finalcomm = comm;
    let coupon = 0;

    if (_discount > 0) {
      coupon = parseInt(_discount * rate); // 쿠폰 사용분
      finalcomm = parseInt(coupon * (comm / final)); // 쿠폰의 수수료 비
      final = fee - (coupon - finalcomm) + comm - finalcomm;
      finalcomm = comm - finalcomm;
    }

    return {
      rate: rate,
      fee: fee,
      comm: comm,
      total: fee + comm,
      final: final,
      finalcomm: finalcomm,
      coupon: coupon,
    };
  },

  apply_promotion(promrec, amount, remain) {
    let coupon = {};

    coupon.discount = parseInt(amount * (promrec.PROM_DISCRT / 10000));
    coupon.discount = Math.min(coupon.discount, remain);
    coupon.remain = remain - coupon.discount;

    return coupon;
  },
};

const converter = {
  encrypt: (text, isUid) => {
    let encryptText = [];

    const pidArray = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j"]; // pid Number to Char (0-9)
    const uidArray = ["k", "l", "m", "n", "o", "p", "q", "r", "s", "t"];

    const convertLetterToNumber = (str) => {
      str = str.toUpperCase();
      let out = 0,
        len = str.length;
      for (let pos = 0; pos < len; pos++) {
        out += (str.charCodeAt(pos) - 64) * Math.pow(26, len - pos - 1);
      }
      return out;
    };

    for (let i = 0; i < text.length; i++) {
      const element = text[i];

      // element가 문자
      if (isNaN(Number(element))) {
        encryptText.push(convertLetterToNumber(element));
      } else {
        encryptText.push(
          isUid ? uidArray[Number(element)] : pidArray[Number(element)]
        );
      }
    }

    return encryptText.join().replace(/,/g, "");
  },

  decrypt: (encryptedText, isUid) => {
    let decryptText = [];

    const pidArray = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j"]; // pid Number to Char
    const uidArray = ["k", "l", "m", "n", "o", "p", "q", "r", "s", "t"];
    // u v w x y z

    for (let i = 0; i < encryptedText.length; i++) {
      const element = encryptedText[i];

      // element가 문자
      if (isNaN(Number(element))) {
        decryptText.push(
          isUid ? uidArray.indexOf(element) : pidArray.indexOf(element)
        );
      } else {
        decryptText.push(pidArray[Number(element) - 1]);
      }
    }

    return parseInt(decryptText.join().replace(/,/g, ""), 16);
  },
};

// 파티 메일 변환 함수
export const inviteMemberEmailConverter = (pid, uid, encryptedEmail) => {
  const mailId = encryptedEmail ? encryptedEmail?.split("@")[0] : "";

  const hexedPid = Number(pid).toString(16);
  const hexedUid = Number(uid).toString(16);

  const encryptedHexedPid = encryptedEmail
    ? mailId?.split("_")[0]
    : converter.encrypt(hexedPid);
  const encryptedHexedUid = encryptedEmail
    ? mailId?.split("_")[1]
    : converter.encrypt(hexedUid, true);

  return encryptedEmail
    ? `${converter.decrypt(encryptedHexedPid)}_${converter.decrypt(
      encryptedHexedUid,
      true
    )}`
    : `${encryptedHexedPid}_${encryptedHexedUid}@linkidmail.com`;
};

// 포워딩 메일 변환 함수
export const emailForwardConverter = (pid, uid, encryptedEmail, isBeta) => {
  const mailId = encryptedEmail ? encryptedEmail?.split("@")[0] : "";

  const hexedPid = Number(pid).toString(16);
  const hexedUid = Number(uid).toString(16);

  const encryptedHexedPid = encryptedEmail
    ? mailId?.split("_")[0]
    : converter.encrypt(hexedPid);
  const encryptedHexedUid = encryptedEmail
    ? mailId?.split("_")[1]
    : converter.encrypt(hexedUid, true);

  return encryptedEmail
    ? `${converter.decrypt(encryptedHexedPid)}_${converter.decrypt(
      encryptedHexedUid,
      true
    )}`
    : `${encryptedHexedPid}_${encryptedHexedUid}@${isBeta ? `testgrove.pw` : `linkidmail.com`
    }`;
};

// Sencond 메일 변환 함수
export const mailmonitorConverter = (ownerid, subid, pidx, isDecrypt) => {
  //  const mailId = isDecrypt ? isDecrypt?.split("@")[0] : "";
  let getInfo = isDecrypt.split("@");

  if (getInfo != null) {
    return getInfo[0].split("_");
  }

  return null;

  const mailID = isDecrypt.split("@");

  const hexedOid = Number(ownerid).toString(16);
  const hexedSid = Number(subid).toString(16);
  const hexedPid = Number(pidx).toString(16);

  const encryptedHexedOid = isDecrypt
    ? mailID?.split("_")[0]
    : converter.encrypt(hexedOid);
  const encryptedHexedSid = isDecrypt
    ? mailID?.split("_")[1]
    : converter.encrypt(hexedSid, true);
  const encryptedHexedPid = isDecrypt
    ? mailID?.split("_")[2]
    : converter.encrypt(hexedPid, true);

  return isDecrypt
    ? `${converter.decrypt(encryptedHexedOid)}_${converter.decrypt(
      encryptedHexedSid,
      true
    )}_${converter.decrypt(encryptedHexedPid, true)}`
    : `${encryptedHexedOid}_${encryptedHexedSid}_${encryptedHexedPid}@linkidmail.net`;
};

// secondary 메일 변환 함수
export const secodaryMailConverter = (
  ownerId, // 복호화시 0
  servId, // 복호화시 0
  pIndex, // 복호화시 0
  encryptedEmail, // 암호화된 메일 (복호화 할 때만 필요)
  isBeta
) => {
  const mailId = encryptedEmail ? encryptedEmail?.split("@")[0] : "";

  const hexedOwnerId = Number(ownerId).toString(16);
  const hexedServId = Number(servId).toString(16);
  const hexedPIndex = Number(pIndex).toString(16);

  const encryptedHexedOwnerid = encryptedEmail
    ? mailId?.split("z")[0]
    : converter.encrypt(hexedOwnerId);
  const encryptedHexedServId = encryptedEmail
    ? mailId?.split("z")[1]?.split("_")[0]
    : converter.encrypt(hexedServId, true);
  const encryptedHexedPIndex = encryptedEmail
    ? mailId?.split("_")[1]
    : converter.encrypt(hexedPIndex);

  return encryptedEmail
    ? // 복호화 값
    `${converter.decrypt(encryptedHexedOwnerid)}_${converter.decrypt(
      encryptedHexedServId,
      true
    )}_${encryptedHexedPIndex}`
    : // 암호화 값
    `${encryptedHexedOwnerid}z${encryptedHexedServId}_${pIndex}@${isBeta ? `testgrove.pw` : `linkidmail.net`
    }`;
};

// get whether subscription is now activate.
export const getThisSubsIsActive = (_subsrec) => {
  const subsAdate = _subsrec.SUBS_ADATE;
  const subsEdate = _subsrec.SUBS_EDATE;

  const now = moment(moment().format("YYYY-MM-DD HH:mm"));

  const isNowBetween = moment(now).isBetween(
    moment(subsAdate).format("YYYY-MM-DD HH:mm"),
    moment(subsEdate).format("YYYY-MM-DD HH:mm")
  );

  if (_subsrec.SUBS_ACT == "activate" && isNowBetween) {
    return true;
  }
  return false;
};


// 넷플릭스 추가공유 비밀번호 랜덤생성
export const makeNetfMemberPw = (uid) => {

  //     총 8자리
  // 첫 번째 자리 문자 대문자 영문 23자 중 1자
  // 이후 7자리 영문소문자 & 숫자

  // 영문에서는 O, I, L 제외
  // 숫자에서는 1, 0 제외

  // ex. A2df9dec

  let pwValues = {
    pw: "",   //일반 값
    pw_enc: ""    //암호화 한 값
  }

  const chars_First = 'ABCDEFGHJKMNPQRSTUVWXYZ';
  const chars = 'ABCDEFGHJKMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789';
  // 첫 대문자 뽑기
  pwValues.pw = chars_First.charAt(Math.floor(Math.random() * chars_First.length));

  //이후 7자리 뽑기
  for (let i = 0; i < 7; i++) {
    pwValues.pw += chars.charAt(Math.floor(Math.random() * chars.length));
  }

  // // 암호화 시키기
  // pwValues.pw_enc = encryptPW(pwValues.pw, uid);

  return pwValues;
}


// export const encryptPW = (pw, uid) => {
//   const pwJson = JSON.stringify(pw);
//   var key = CryptoJS.enc.Utf8.parse(servicePWcrypto.Key(uid));
//   var iv = CryptoJS.enc.Utf8.parse(servicePWcrypto.IV);
//   var aesEncryptor = CryptoJS.algo.AES.createEncryptor(key, { iv: iv });

//   var ddd = aesEncryptor.process(pwJson);

//   var final = aesEncryptor.finalize();

//   return ddd.toString(CryptoJS.enc.Hex) + final.toString(CryptoJS.enc.Hex);
// };